export default "__VITE_PUBLIC_ASSET__123d489d__"